var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-segment",class:[ _vm.segmentData.style ? `${_vm.segmentData.style}-style` : null ]},[_c('h3',[_vm._v(_vm._s(_vm.segmentData.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }